import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ModeTransitionEligibility } from '../types/mode.types';
import { checkTransitionEligibility, requestModeTransition } from '../services/modeService';

/**
 * Hook to check transition eligibility
 * Calls backend endpoint to get real-time eligibility data
 */
export const useTransitionEligibility = (siteId: number) => {
  return useQuery<ModeTransitionEligibility>({
    queryKey: ['transitionEligibility', siteId],
    queryFn: () => checkTransitionEligibility(siteId),
    enabled: !!siteId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

/**
 * Hook to request manual transition to Performance mode
 */
export const useRequestTransition = (siteId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => requestModeTransition(siteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['siteMode', siteId] });
      queryClient.invalidateQueries({ queryKey: ['transitionEligibility', siteId] });
    },
  });
};
